import { theme } from '@febos-io/design';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../providers';

export function SignOutPage() {
  const location = useLocation();
  const [cleared, setCleared] = useState(false);
  const { signInPathname } = useAuthContext();
  useEffect(() => {
    localStorage.clear();
    setCleared(true);
  }, []);
  if (cleared) {
    return <Navigate to={signInPathname} state={{ from: location }} replace />;
  }
  return (
    <theme.views.Login>
      <span>saliendo</span>
    </theme.views.Login>
  );
}

export default SignOutPage;
